import { ProductsState } from './products.types'

export default (): ProductsState => ({
  data: {},
  filters: {}
})
